import NetworkErrorDark from '@/assets/images/_neterror@3x.png'
import NetworkErrorLight from '@/assets/images/lightIcon/_neterror@3x.png'
import { useSystemDark } from '@/hooks'
import { useEffect } from 'react'
import { useRouteError, useNavigate } from 'react-router-dom'

const ErrorBoundary = () => {
  const isDarkMode = useSystemDark()
  const routeError = useRouteError()
  const navigate = useNavigate()

  useEffect(() => {
    if (routeError) {
      console.error('[Route Error]', routeError)
    }
  }, [routeError])

  const handleGoHome = () => {
    navigate('/home/discover', { replace: true })
  }

  const is404Error = routeError && typeof routeError === 'object' && 'status' in routeError && (routeError as { status: number }).status === 404

  return (
    <div className='flex h-[100dvh] flex-col items-center justify-center'>
      <img src={isDarkMode ? NetworkErrorDark : NetworkErrorLight} className='mb-[30px] h-[131px] w-[254px]' alt='error' />

      <p className='mb-[24px] font-geologica text-[30px] font-normal text-base-text-color'>{is404Error ? 'Page not found' : 'An error occurred'}</p>

      <div className='flex gap-8'>
        <button className={`g-btn-v2 p-[20px]`} onClick={handleGoHome}>
          Go Back
        </button>
        <button
          className={`g-btn-v2 p-[20px]`}
          onClick={() => {
            window.location.reload()
          }}
        >
          Retry
        </button>
      </div>
    </div>
  )
}

export default ErrorBoundary
